import React, {useEffect} from "react"
import Card from "@irati/ui/src/Layout/Card"
import {votesQuery} from "@irati/recognition/apollo/query/Votes"
import {DisablePointerEventsOnScroll} from "@irati/ui/src/DisablePointerEventsOnScroll"
import tracking from "@irati-tracking/recognition/navigation"
import {match as Match} from "react-router-dom"
import {NestedRoute} from "@irati/utils/history/routing"
import {feedPollQuery} from "@irati/recognition/apollo/query/FeedPoll"
import {Query} from "@irati/utils/services/apollo"
import VotesPopup from "../../../components/Popup/Votes"
import ErrorPopup from "../../../components/Popup/Error"
import Votes from "./Votes"

interface Props {
  match: Match
}
const Popups = (props: Props) => {
  const {
    params: {uuid}
  } = props.match
  return (
    <>
      {uuid && (
        <Query query={feedPollQuery.query} variables={{id: uuid}} Error={ErrorPopup}>
          {({data: {poll}}) => <VotesPopup poll={poll} redirectToFeed />}
        </Query>
      )}
    </>
  )
}
const AccountVotes = () => {
  useEffect(() => {
    tracking.viewProfile()
  }, [])
  const votesProps = {...votesQuery, variables: votesQuery.variables}

  return (
    <>
      <Card tiny noBorder>
        <DisablePointerEventsOnScroll>
          <Votes votes={votesProps} />
        </DisablePointerEventsOnScroll>
      </Card>
      <NestedRoute useGrid={false} match={"/recognition/account/my-votes"} path={`/poll/:uuid`} title="Poll votes" component={Popups} />
    </>
  )
}

export default AccountVotes
